// extracted by mini-css-extract-plugin
module.exports = {"callOutTextContainer":"CallOutText_callOutTextContainer__2Sl15","callOutText":"CallOutText_callOutText__tnvCe"};